import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { LOGO_URL } from "../lib/constants";
import { LifeBuoy, Shield, LogOut } from "lucide-react";
import { getUser, clearAuth } from "../lib/api";
import { Button } from "../components/ui/button";

export default function Header({ showAdminLink = true }) {
  const navigate = useNavigate();
  const location = useLocation();
  const user = getUser();

  const handleLogout = () => {
    clearAuth();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-30 backdrop-blur-xl bg-black/60 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-3 flex items-center justify-between">
        <Link to="/" data-testid="header-logo-link" className="flex items-center gap-3 group">
          <img
            src={LOGO_URL}
            alt="LMKT"
            className="h-10 w-10 md:h-12 md:w-12 object-contain drop-shadow-[0_0_12px_rgba(255,87,34,0.5)]"
          />
          <div className="hidden sm:block">
            <div className="text-white font-black tracking-tight leading-none text-base md:text-lg">
              LMKT
            </div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-cyan-300/80 leading-none mt-1">
              Music & Video SEND
            </div>
          </div>
        </Link>

        <nav className="flex items-center gap-2 md:gap-3">
          <Link to="/assistenza" data-testid="header-assistance-link">
            <Button
              variant="ghost"
              className="text-cyan-300 hover:text-white hover:bg-white/10 rounded-full"
            >
              <LifeBuoy className="w-4 h-4 mr-1.5" />
              <span className="hidden sm:inline">Assistenza</span>
            </Button>
          </Link>

          {user ? (
            <>
              {user.role === "admin" && (
                <Link to="/admin" data-testid="header-admin-link">
                  <Button
                    variant="ghost"
                    className="text-orange-300 hover:text-white hover:bg-white/10 rounded-full"
                  >
                    <Shield className="w-4 h-4 mr-1.5" />
                    <span className="hidden sm:inline">Admin</span>
                  </Button>
                </Link>
              )}
              {user.role === "dj" && (
                <Link to="/admin/dj" data-testid="header-dj-link">
                  <Button
                    variant="ghost"
                    className="text-cyan-300 hover:text-white hover:bg-white/10 rounded-full"
                  >
                    <Shield className="w-4 h-4 mr-1.5" />
                    <span className="hidden sm:inline">Area DJ</span>
                  </Button>
                </Link>
              )}
              <Button
                onClick={handleLogout}
                data-testid="header-logout-btn"
                variant="ghost"
                className="text-red-300 hover:text-white hover:bg-white/10 rounded-full"
              >
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            showAdminLink &&
            !location.pathname.startsWith("/admin") && (
              <Link to="/admin/login" data-testid="header-admin-login-link" className="hidden sm:block">
                <Button
                  variant="ghost"
                  className="text-white/60 hover:text-white hover:bg-white/10 rounded-full text-xs"
                >
                  <Shield className="w-3.5 h-3.5 mr-1" />
                  <span>Area Riservata</span>
                </Button>
              </Link>
            )
          )}
        </nav>
      </div>
    </header>
  );
}
